import React, { useEffect, useRef } from 'react'
import SummaryPicture from '../../../../partials/ContentGrid/SummaryPicture'
import { ContentGrid } from '../../../../partials/ContentGrid'
import SectionWithTag from '../../../../components/SectionWithTag'
import { FormattedMessage } from 'react-intl'
import { useIsMobile } from '../../../../utils/helpers'
import { SetPaddingProps } from '../../../../utils/PaddingContext'

const id = 'page.homepage.proteins'

const AboutSummary = ({ setPadding }: SetPaddingProps) => {
    const leftRef = useRef<HTMLDivElement>(null)
    const rightRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)
    const isMobile = useIsMobile()
    useEffect(() => {
        const calculatePadding = () => {
            requestAnimationFrame(() => {
                if (leftRef.current && rightRef.current && contentRef.current && !isMobile) {
                    const pad = {
                        paddingLeft:
              leftRef.current.getBoundingClientRect().left -
              contentRef.current.getBoundingClientRect().left,
                        paddingRight:
              window.innerWidth -
              rightRef.current.getBoundingClientRect().right -
              contentRef.current.getBoundingClientRect().left,
                    }
                    setPadding(pad)
                } else {
                    setPadding()
                }
            })
        }
        calculatePadding()
        window.addEventListener('resize', calculatePadding)
        return () => {
            window.removeEventListener('resize', calculatePadding)
        }
    }, [leftRef, rightRef, isMobile, contentRef])
    return (
        <div className='border-t border-black/10 bg-white'>
            <ContentGrid className='3xl:max-w-screen-2xl mx-auto'>
                <div className='md:aspect-square aspect-auto' ref={contentRef}>
                    <SectionWithTag
                        tag={{ id: `${id}.tag`, className: 'pr-0' }}
                        className='bg-white content-grid--tag'
                        contentClasses='w-screen md:w-full'
                    >
                        <div className='py-10 md:p-0 md:aspect-square flex items-center justify-center'>
                            <div className='flex flex-col gap-y-10 md:max-w-[410px]' ref={leftRef}>
                                <FormattedMessage id={id} tagName='h2' />
                                <FormattedMessage id={`${id}.description`} tagName='p' />
                            </div>
                        </div>
                    </SectionWithTag>
                </div>
                <div className='md:p-[15%]'>
                    <div ref={rightRef}>
                        <SummaryPicture slug='horizons' imageClassName='w-full' className='md:aspect-square' />
                    </div>
                </div>
            </ContentGrid>
        </div>
    )
}

export default AboutSummary
